import {
  LockClosedIcon,
  ShareIcon,
  AdjustmentsVerticalIcon,
  EyeSlashIcon,
} from '@heroicons/react/24/outline';

const trustPoints = [
  { icon: LockClosedIcon, title: 'Older adults stay in control', description: 'Your data, your decisions, your pace.' },
  { icon: ShareIcon, title: 'Information is shared intentionally', description: 'Nothing is visible without clear consent.' },
  { icon: AdjustmentsVerticalIcon, title: 'Visibility is role-based and adjustable', description: 'Each person sees only what they need.' },
  { icon: EyeSlashIcon, title: 'Full autonomy. Full dignity.', description: 'We support daily life, respectfully and intentionally.' },
];

const PrivacyTrustSection = () => {
  return (
    <div className="py-24 lg:py-32 bg-muted/10">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
              Built for Dignity, Control, and Trust
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed max-w-xl mx-auto">
              SeniorThrive is designed to respect independence and privacy at
              every step.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
            {trustPoints.map((point) => (
              <div
                key={point.title}
                className="p-6 rounded-md bg-background shadow-raised"
              >
                <div className="flex items-center gap-3 mb-2">
                  <point.icon className="w-7 h-7 text-foreground flex-shrink-0" />
                  <h3 className="font-bold text-foreground">{point.title}</h3>
                </div>
                <p className="text-sm text-muted-foreground pl-[52px]">{point.description}</p>
              </div>
            ))}
          </div>

          <p className="text-center text-muted-foreground italic text-lg mt-12">
            Support should feel empowering, always.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyTrustSection;
